import { getTestIdProps } from '@lib/testUtils';
import { inboxLocators } from '@locators/inbox';
import { Text } from '@servicetitan/anvil2';
import styles from './LiveServicesDetails.module.css';

type Props = {
  notes?: string | null;
  url?: string | null;
};

const ALLOWED_URL_PROTOCOLS = new Set(['http:', 'https:']);

function getLiveServicesUrl(url?: string | null) {
  const trimmedUrl = url?.trim();
  if (!trimmedUrl) {
    return undefined;
  }

  try {
    const parsedUrl = new URL(trimmedUrl);
    return {
      text: trimmedUrl,
      href: ALLOWED_URL_PROTOCOLS.has(parsedUrl.protocol)
        ? trimmedUrl
        : undefined,
    };
  } catch {
    return { text: trimmedUrl, href: undefined };
  }
}

export const LiveServicesDetails = ({ notes, url }: Props) => {
  const liveServicesUrl = getLiveServicesUrl(url);

  if (!notes && !liveServicesUrl) {
    return null;
  }

  return (
    <>
      {notes && (
        <div
          className={styles.liveServicesTextRow}
          {...getTestIdProps(inboxLocators.taskList.liveServicesNotes)}
        >
          <Text
            variant='eyebrow'
            size='small'
            className={styles.liveServicesLabel}
          >
            Notes:
          </Text>
          <Text
            size='small'
            variant='body'
            className={styles.liveServicesWrappedText}
          >
            {notes}
          </Text>
        </div>
      )}
      {liveServicesUrl && (
        <div
          className={styles.liveServicesLinkRow}
          {...getTestIdProps(inboxLocators.taskList.liveServicesUrl)}
        >
          <Text
            variant='eyebrow'
            size='small'
            className={styles.liveServicesLabel}
          >
            URL:
          </Text>
          <Text
            size='small'
            variant='body'
            className={styles.liveServicesLinkText}
          >
            {liveServicesUrl.href ? (
              <a
                className={styles.liveServicesLink}
                href={liveServicesUrl.href}
                target='_blank'
                rel='noopener noreferrer'
                title={liveServicesUrl.text}
                onClick={(event) => event.stopPropagation()}
              >
                {liveServicesUrl.text}
              </a>
            ) : (
              liveServicesUrl.text
            )}
          </Text>
        </div>
      )}
    </>
  );
};
